export enum ServerValidationStatus {
  untouched = 'untouched',
  notValidated = 'notValidated',
  valid = 'valid',
  unauthorized = 'unauthorized',
  invalidServer = 'invalidServer',
  invalidCredentials = 'invalidCredentials'
}
